/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {ChessConsole} from "../../lib/chess-console/ChessConsole.js"
import {GambitChessConsoleState} from "./GambitChessConsoleState.js"
import {Board} from "./components/Board.js"
import {History} from "./components/History.js"
import {Sound} from "./components/Sound.js"
import {COLOR} from "../../lib/cm-chessboard/Chessboard.js"
import {GameControls} from "./components/GameControls.js"
import {Clock} from "./components/Clock.js"
import {gameEventAction} from "../chess-console-app/websocket/GambitWebSocketConnection.js"
import {get} from "svelte/store"
import {sessionData} from "../stores.js"

export class GambitChessConsole extends ChessConsole {
    constructor(app, context, props) {
        if(!context) {
            throw new Error("context is", context)
        }
        super(context,
            props.playerData,
            props.opponentData,
            {
                figuresSpriteFile: "/assets/images/chessboard-sprite.svg?v=" + app.props.resourcesCacheKey,
                playerColor: props.playerColor,
                playPage: props.playPage
            }, new GambitChessConsoleState(props))
        this.app = app
        this.components = {
            board: new Board(this, {
                animationDuration: props.animationDuration
            }),
            clock: new Clock(this),
            gameControls: new GameControls(this),
            history: new History(this),
            sound: new Sound(this, {
                soundSpriteFile: "/assets/sounds/chessmail3.5b.mp3"
            })
        }
        this.components.board.initialization.then(() => {
            super.initGame()
        })
        this.initialization.then(() => {
            /*
            const lastServerFen = props.initialState._fenList[props.initialState._fenList.length - 1]
            this.state.chess.load(lastServerFen)
             */
        })
    }

    onMove(color, move) {
        if(color !== this.props.playerColor) {
            this.opponent.onMove(move)
        }
    }
    isWhiteMove() {
        return this.app.state.gameState._uciMoves.length % 2 === 0
    }
    isPlayerWhite() {
        return this.props.playerColor === COLOR.white
    }
    isGameRunning() {
        return !this.app.state.gameState._outcome
    }
    acceptDraw() {
        this.app.webSocketConnection.sendGameEvent(this.app.props.accessToken, gameEventAction.OFFER_DRAW)
    }
    declineDraw() {
        this.app.webSocketConnection.sendGameEvent(this.app.props.accessToken, gameEventAction.DRAW_OFFER_DECLINE)
    }
    resign() {
        this.app.webSocketConnection.sendGameEvent(this.app.props.accessToken, gameEventAction.RESIGN)
        const sessionDataValue = get(sessionData)
        sessionDataValue.showResignDialog = false
        sessionData.set(sessionDataValue)
    }
}
